import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/web.timers.js";
import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AzCarousel',
  props: {
    align: {
      type: String,
      default: 'left'
    },
    pagination: {
      type: Boolean,
      default: false
    },
    scrollMode: {
      type: String,
      default: 'size'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var carouselRef = ref(null);
    var currentSlide = ref(0);
    var childElementCount = ref(0);
    var currentScroll = ref(0);
    var scrollWidth = ref(0);

    /**
     * Slides the carousel to the given index
     *
     * @param      {number}  index   The index
     */
    function slideTo(index) {
      var _carouselRef$value, _carouselRef$value$ch, _carouselRef$value$ch2;
      if (index < 0 || index > childElementCount.value - 1) return;
      var elementOffset = (_carouselRef$value = carouselRef.value) === null || _carouselRef$value === void 0 ? void 0 : (_carouselRef$value$ch = _carouselRef$value.children) === null || _carouselRef$value$ch === void 0 ? void 0 : (_carouselRef$value$ch2 = _carouselRef$value$ch[index]) === null || _carouselRef$value$ch2 === void 0 ? void 0 : _carouselRef$value$ch2.offsetLeft;
      var newScroll = Math.min(elementOffset, scrollWidth.value);
      carouselRef.value.scrollTo(newScroll, 0);
      currentScroll.value = newScroll;
    }

    /**
     * Slides to the previous slide
     */
    function prevSlide() {
      slideTo(currentSlide.value - 1);
    }

    /**
     * Slides to the nex slide
     */
    function nextSlide() {
      slideTo(currentSlide.value + 1);
    }

    /**
     * Initializes the carousel.
     */
    function init() {
      childElementCount.value = carouselRef.value.childElementCount;
      updateScrollValues();
    }

    // Get scroll end event
    var isScrolling = null;
    var onScroll = function onScroll() {
      if (isScrolling) window.clearTimeout(isScrolling);
      isScrolling = setTimeout(updateScrollValues, 120);
    };

    /**
     * Updates the carousel scroll data to match user scroll with button actions
     */
    function updateScrollValues() {
      var _carouselRef$value$ch3, _carouselRef$value2, _carouselRef$value3, _carouselRef$value4, _carouselRef$value5;
      var children = (_carouselRef$value$ch3 = (_carouselRef$value2 = carouselRef.value) === null || _carouselRef$value2 === void 0 ? void 0 : _carouselRef$value2.children) !== null && _carouselRef$value$ch3 !== void 0 ? _carouselRef$value$ch3 : [];
      currentScroll.value = (_carouselRef$value3 = carouselRef.value) === null || _carouselRef$value3 === void 0 ? void 0 : _carouselRef$value3.scrollLeft;
      var scrollCurrentSlide = _toConsumableArray(children).findIndex(function (i) {
        return i.offsetLeft >= currentScroll.value;
      });
      currentSlide.value = scrollCurrentSlide >= 0 ? scrollCurrentSlide : childElementCount.value - 1;
      scrollWidth.value = ((_carouselRef$value4 = carouselRef.value) === null || _carouselRef$value4 === void 0 ? void 0 : _carouselRef$value4.scrollWidth) - ((_carouselRef$value5 = carouselRef.value) === null || _carouselRef$value5 === void 0 ? void 0 : _carouselRef$value5.clientWidth);
    }
    var isPrevAvailable = computed(function () {
      var _carouselRef$value6, _carouselRef$value7;
      if (((_carouselRef$value6 = carouselRef.value) === null || _carouselRef$value6 === void 0 ? void 0 : _carouselRef$value6.scrollWidth) === undefined || ((_carouselRef$value7 = carouselRef.value) === null || _carouselRef$value7 === void 0 ? void 0 : _carouselRef$value7.scrollWidth) === null) return false;
      return props.scrollMode === 'slide' ? currentSlide.value > 0 : currentScroll.value > 0;
    });
    var isNextAvailable = computed(function () {
      var _carouselRef$value8, _carouselRef$value9;
      if (((_carouselRef$value8 = carouselRef.value) === null || _carouselRef$value8 === void 0 ? void 0 : _carouselRef$value8.scrollWidth) === undefined || ((_carouselRef$value9 = carouselRef.value) === null || _carouselRef$value9 === void 0 ? void 0 : _carouselRef$value9.scrollWidth) === null) return false;
      return props.scrollMode === 'slide' ? currentSlide.value < childElementCount.value - 1 : currentScroll.value < scrollWidth.value;
    });
    onMounted(function () {
      init();
    });
    return {
      __sfc: true,
      props: props,
      carouselRef: carouselRef,
      currentSlide: currentSlide,
      childElementCount: childElementCount,
      currentScroll: currentScroll,
      scrollWidth: scrollWidth,
      slideTo: slideTo,
      prevSlide: prevSlide,
      nextSlide: nextSlide,
      init: init,
      isScrolling: isScrolling,
      onScroll: onScroll,
      updateScrollValues: updateScrollValues,
      isPrevAvailable: isPrevAvailable,
      isNextAvailable: isNextAvailable
    };
  }
});